import type { Comment, UpdateCommentBody } from '@tasks/contracts';

import type { Page } from '../lib/types';
import { apiRequest, apiRequestResource, apiRequestVoid } from './client';

export function listComments(
  issueKey: string,
  params: { limit?: number; offset?: number } = {},
  signal?: AbortSignal,
): Promise<Page<Comment>> {
  return apiRequest<Page<Comment>>(`/issues/${encodeURIComponent(issueKey)}/comments`, {
    query: { limit: params.limit, offset: params.offset },
    signal,
  });
}

export function createComment(issueKey: string, body: string): Promise<Comment> {
  return apiRequestResource<Comment>(`/issues/${encodeURIComponent(issueKey)}/comments`, 'comment', {
    method: 'POST',
    body: { body, parentId: null },
  });
}

export function updateComment(commentId: string, body: UpdateCommentBody): Promise<Comment> {
  return apiRequestResource<Comment>(`/comments/${encodeURIComponent(commentId)}`, 'comment', {
    method: 'PATCH',
    body,
  });
}

export function deleteComment(commentId: string): Promise<void> {
  return apiRequestVoid(`/comments/${encodeURIComponent(commentId)}`, { method: 'DELETE' });
}
